export default class ResourceJwtServices {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.permissionsEndpoint}/resources`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.permissionsEndpoint}/resources/${id}`)
  }

  create(payload) {
    return this.axiosIns.post(`${this.jwtConfig.main.permissionsEndpoint}/resources`, payload);
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.permissionsEndpoint}/resources/${id}`, payload)
  }

  deactivate(id, payload) {
    return this.axiosIns.put(`${this.jwtConfig.main.permissionsEndpoint}/resources/${id}`, payload)
  }
}
